<template>
    <div>
        <div class="container-fluid container-fluid--bg-red edge--bottom content-top">
            <div class="row">
                <div class="col-sm">
                    <transition-group appear name="fade" :duration="500">
                        <h1 :key="title">{{ title }}</h1>
                    </transition-group>
                </div>
            </div>
        </div>
        <section class="container container--bg-transparent container--negative-top-margin">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3" v-for="card in cards" :key="card.title">
              <card-element 
                :cardTitle="card.title"
                :cardText="card.text"
                :cardImageSrc="card.imageSrc"
                :cardImageAltText="card.imageAltText"
                :cardLinkText="card.linkText"
                :cardLinkUrl="card.linkUrl">
              </card-element>
            </div>
          </div>
        </section>
    </div>
</template>

<script>
import CardElement from './Card-Element';

export default {
    data() {
        return {
            title: 'Tuff Shed Marketing Tools',
            cards: [
                {
                    title: 'Signature Tool',
                    text: 'Create your Tuff Shed email signature',
                    imageSrc: './assets/images/trianglify.png',
                    imageAltText: 'A Signature Alt Text',
                    linkText: 'Create Your Signature',
                    linkUrl: '/signature'
                },
                {
                    title: 'Projects',
                    text: 'Coming Soon...',
                    imageSrc: './assets/images/trianglify.png',
                    imageAltText: null,
                    linkText: 'Lets Go',
                    linkUrl: '/projects'
                },
                {
                    title: 'Templates',
                    text: 'Coming Soon...',
                    imageSrc: './assets/images/trianglify.png',
                    imageAltText: null,
                    linkText: 'Lets Go',
                    linkUrl: '/templates'
                },
                {
                    title: 'Tuff Shed Store',
                    text: 'Coming Soon...',
                    imageSrc: './assets/images/trianglify.png',
                    imageAltText: null,
                    linkText: null,
                    linkUrl: null
                }
            ]
        }
    },
    components: {
      CardElement
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .content-top {
        position: relative;
    }
</style>
